import React from 'react';

import { widgetStyle, smallTextStyle } from '../../../styles/constants';

/**
 * Props for the Input component
 */
export interface InputProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
  /** Optional label text shown above input */
  hint?: string;
  /** HTML input type (default: "text") */
  type?: string;
  /** Current input value */
  value: string;
  /** Placeholder text */
  placeholder?: string;
  /** Callback when value changes (receives new value string) */
  onChange: (value: string) => void;
  /** Whether input is disabled */
  disabled?: boolean;
  /** Callback for key press events */
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

/**
 * Input Component - Styled text input with optional hint label
 *
 * A reusable input component with consistent styling and an optional
 * hint label displayed above the input field.
 *
 * @example
 * <Input
 *   hint="Username"
 *   type="text"
 *   value={username}
 *   onChange={setUsername}
 *   placeholder="Enter your username"
 * />
 */
export const Input: React.FC<InputProps> = ({
  hint,
  type = 'text',
  value,
  placeholder,
  onChange,
  disabled,
  onKeyPress,
  ...props
}) => {
  return (
    <div {...props}>
      {/* Optional hint label */}
      <div
        style={{
          ...smallTextStyle,
          textAlign: 'left',
          fontStyle: 'italic',
          marginBottom: '-2vmin',
        }}
      >
        {hint}
      </div>

      {/* Input field */}
      <input
        style={{ ...widgetStyle, width: '90%' }}
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        onKeyPress={onKeyPress}
        disabled={disabled}
      />
    </div>
  );
};

export default Input;
